<template>
  <div class="map-wrapper">
    <div
      class="map"
      ref="map"
    />
  </div>
</template>

<script>

export default {
  name: 'AppMap',
  data () {
    return {
      geocodes: []
    }
  },
  async created () {
    await this.fetchDots()
    this.initMap()
  },
  methods: {
    async fetchDots () {
      try {
        const { data } = await this.$api.events.dots()
        const geocodes = data?.geocodes ?? []
        this.geocodes = geocodes.map(item => ({
          id: item.id,
          coords: [item.lat, item.lng]
        }))
      } catch (e) {
        console.log(e)
      }
    },
    initMap () {
      const ymaps = window.ymaps
      const map = this.$refs.map

      const init = () => {
        const mapObject = new ymaps.Map(map, {
          center: [55.76, 37.64],
          zoom: 5
        })

        this.geocodes.forEach(item => {
          const placemark = new ymaps.Placemark(item.coords)

          placemark.events.add('click', function () {
            window.location = `/events/${item.id}`
          })

          mapObject.geoObjects.add(placemark)
        })
      }

      ymaps.ready(init)
    }
  }
}
</script>

<style lang="scss" scoped>
.map {
  height: 100%;
}
</style>
